/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Supplier reservation attachment only, not membership validation or guaranteed mileage/benefits. Contains no account number or traveler name.
 * @export
 * @interface FlightLoyaltyAttachment
 */
export interface FlightLoyaltyAttachment {
  /**
   * One-based traveler position in the immutable booking request.
   * @type {number}
   * @memberof FlightLoyaltyAttachment
   */
  travelerIndex: number;
  /**
   *
   * @type {string}
   * @memberof FlightLoyaltyAttachment
   */
  airlineIataCode: string;
  /**
   *
   * @type {string}
   * @memberof FlightLoyaltyAttachment
   */
  status: FlightLoyaltyAttachmentStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightLoyaltyAttachment
   */
  reason: FlightLoyaltyAttachmentReasonEnum;
}

/**
 * @export
 */
export const FlightLoyaltyAttachmentStatusEnum = {
  Submitted: "submitted",
  SupplierConfirmed: "supplier_confirmed",
  Unverified: "unverified",
} as const;
export type FlightLoyaltyAttachmentStatusEnum =
  (typeof FlightLoyaltyAttachmentStatusEnum)[keyof typeof FlightLoyaltyAttachmentStatusEnum];

/**
 * @export
 */
export const FlightLoyaltyAttachmentReasonEnum = {
  AwaitingSupplierEvidence: "awaiting_supplier_evidence",
  RecordedOnReservation: "recorded_on_reservation",
  EvidenceUnavailable: "evidence_unavailable",
  SupplierWarning: "supplier_warning",
  AccountNotReturned: "account_not_returned",
  TravelerNotMatched: "traveler_not_matched",
} as const;
export type FlightLoyaltyAttachmentReasonEnum =
  (typeof FlightLoyaltyAttachmentReasonEnum)[keyof typeof FlightLoyaltyAttachmentReasonEnum];

/**
 * Check if a given object implements the FlightLoyaltyAttachment interface.
 */
export function instanceOfFlightLoyaltyAttachment(
  value: object
): value is FlightLoyaltyAttachment {
  if (!("travelerIndex" in value) || value["travelerIndex"] === undefined)
    return false;
  if (!("airlineIataCode" in value) || value["airlineIataCode"] === undefined)
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  return true;
}

export function FlightLoyaltyAttachmentFromJSON(
  json: any
): FlightLoyaltyAttachment {
  return FlightLoyaltyAttachmentFromJSONTyped(json, false);
}

export function FlightLoyaltyAttachmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightLoyaltyAttachment {
  if (json == null) {
    return json;
  }
  return {
    travelerIndex: json["traveler_index"],
    airlineIataCode: json["airline_iata_code"],
    status: json["status"],
    reason: json["reason"],
  };
}

export function FlightLoyaltyAttachmentToJSON(
  json: any
): FlightLoyaltyAttachment {
  return FlightLoyaltyAttachmentToJSONTyped(json, false);
}

export function FlightLoyaltyAttachmentToJSONTyped(
  value?: FlightLoyaltyAttachment | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    traveler_index: value["travelerIndex"],
    airline_iata_code: value["airlineIataCode"],
    status: value["status"],
    reason: value["reason"],
  };
}
